import React from "react";
import PropTypes from "prop-types";
import Button from "@techsoftware/happay-widgets/Button";
export default class TertiaryButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Button
                {...this.props}
                onClick={this.props.onClick}
                type="button"
                text={this.props.label || this.props.text}
                variant="tertiary"
                buttonParentStyles={Object.assign({}, this.props.buttonParentStyles, {
                    height: this.props.size ? "auto" : 40
                })}
                size={this.props.size || "normal"}
                className={`${this.props.className} ${
                    this.props.isSecondVariant ? "secondVarientBtn padding-l-24 padding-r-24" : ""
                }`}
            />
        );
    }
}
TertiaryButton.propTypes = {
    onClick: PropTypes.func
};

TertiaryButton.defaultProps = {
    onClick: () => {}
};
